"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseCarousel = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _Carousel = require("../../atoms/Carousel");

var _windowUtils = require("../../utils/windowUtils");

var _When = _interopRequireDefault(require("../../utils/When"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getLoadingCarouselItems = function getLoadingCarouselItems(length) {
  return Array(length).fill({
    loading: true
  });
};

var getRoundedElementsPerPage = function getRoundedElementsPerPage(carouselConfig) {
  var windowSize = (0, _windowUtils.getClientWindowSize)(window.innerWidth);
  return Math.max(Math.floor(carouselConfig.navControlsWidth[windowSize] / carouselConfig.itemsWidth[windowSize]), 1);
};

var BaseCarousel = function BaseCarousel(_ref) {
  var items = _ref.items,
      loading = _ref.loading,
      carouselConfig = _ref.carouselConfig,
      itemTemplate = _ref.itemTemplate;

  var _React$useState = _react.default.useState(),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      rootElement = _React$useState2[0],
      setRootElement = _React$useState2[1];

  var getCarouselRef = function getCarouselRef(node) {
    setRootElement(node);
  };

  var getCarouselTemplate = function getCarouselTemplate(props) {
    return itemTemplate(_objectSpread(_objectSpread({}, props), {}, {
      lazyLoading: true,
      observerRootElement: rootElement
    }));
  };

  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_When.default, {
    condition: !!loading
  }, function () {
    return _react.default.createElement(_Carousel.Carousel, {
      hideNavControls: true,
      itemTemplate: getCarouselTemplate,
      items: getLoadingCarouselItems(getRoundedElementsPerPage(carouselConfig) + 1),
      config: carouselConfig
    });
  }), _react.default.createElement(_When.default, {
    condition: !loading
  }, function () {
    return _react.default.createElement("div", {
      ref: getCarouselRef
    }, _react.default.createElement(_Carousel.Carousel, {
      itemTemplate: getCarouselTemplate,
      items: items,
      config: carouselConfig
    }));
  }));
};

exports.BaseCarousel = BaseCarousel;
BaseCarousel.defaultProps = {
  items: [],
  loading: true
};